import Avatar from "@mui/material/Avatar";
import { Box } from "@mui/material";
import { MenuUserSubscriptionContainer } from "./styles";
import { tierMap } from "../../pages/Billing/types";
import { FONT_FAMILY } from "../../theme";

function MenuUser({
  user,
  imageUrl,
  subscriptionTier,
}: {
  user: string;
  imageUrl: string;
  subscriptionTier: number;
}): JSX.Element {
  return (
    <div className="user-container">
      <Avatar alt={user} src={imageUrl} />
      <div>
        <Box sx={{ fontFamily: FONT_FAMILY }} className="user-name">
          {user ? user : "Log in"}
        </Box>
        {user && (
          <MenuUserSubscriptionContainer
            style={{ fontFamily: FONT_FAMILY }}
            className="user-name"
          >
            {tierMap[subscriptionTier]}
          </MenuUserSubscriptionContainer>
        )}
      </div>
    </div>
  );
}

export default MenuUser;
